// src/belediye/components/mesajlasma/ChatDock.js
// Kurum içi mesajlaşma — her rotada sağ-altta MODAL KART.
// FAZ-52: üst şeritte ÜÇ kontrol → orta boy (küçük↔orta), tam ekran (tam↔önceki),
// kapat. Tam ekranda navbar+sidebar HARİÇ alanı kaplar; sol hizalama CSS'teki
// `--md-sidebar-w` değişkeninden gelir (kabuk yazar — ölçüm yok).
// Solda sohbet listesi, sağda mesaj alanı.
//
// Kapılar: uiOn + mesajlasma modülü + mesajlasma.view — izinsizde DOM'da İZ YOK.
// Unread-poll'ün TEK sahibi burasıdır (teslim damgası tek kaynaktan) →
// 'mesajlasma:unread' CustomEvent; navbar ikonu bu olaydan beslenir.

import React, { useCallback, useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { useLocation, useNavigate } from "react-router-dom";
import {
  ArrowsPointingInIcon,
  ArrowsPointingOutIcon,
  ChatBubbleLeftRightIcon,
  ChevronUpDownIcon,
  LockClosedIcon,
  MinusSmallIcon,
  PlusIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";

// FAZ-51: kavram ikonları tek sözlükten (görev ikonu değişti, sohbet türleri
// ayrıştı). FAZ-94: satır ikonları artık SohbetListesi'nde — burada yalnız
// başlatıcı balonunki kaldı.
import { ChatBarIcon } from "../icons/appIcons";

import usePermissions from "../../hooks/usePermissions";
import useModuleEnabled from "../../hooks/useModuleEnabled";
import { playMsjReceived } from "./mesajlasmaSound";
import { fetchConversations, fetchUnreadTotal } from "../../services/mesajlasmaApi";
import {
  MESAJLASMA_NEW_EVENT,
  MESAJLASMA_OPEN_EVENT,
  MESAJLASMA_TOGGLE_EVENT,
} from "../../services/mesajlasmaBridge";
import useMsjFeatures from "./useMsjFeatures";
import useKlavyeAlani from "./useKlavyeAlani";
import { TEK_PENCERE_PX, tekPencereMi } from "./olcu";
// FAZ-90: balon telefonda alt barın merkez düğmesine devroldu
import useKatman from "../../hooks/useKatman";
// FAZ-99 / Y-5: "bu talebin sohbetini aç" köprüsü — saf veri modülünden
// (AltBar.js'ten almak dairesel olurdu; o zaten buradan UNREAD_EVENT çekiyor).
import { GOREV_SOHBET_EVENT } from "../../altbar";
import ChatThread from "./ChatThread";
import SohbetListesi from "./SohbetListesi";
import NewChatPanel from "./NewChatPanel";
import {
  visibleSegments,
  gorevKovaSayilari,
  GOREV_ALT_SUZGEC,
} from "./sohbetKovalari";
import TaskFlowPanel from "./TaskFlowPanel";
import "./chat.css";

export { TEK_PENCERE_PX };

export const UNREAD_EVENT = "mesajlasma:unread";

// FAZ-99 / Y-5 — talep DETAY rotası. AltBar.js'teki `GOREV_DETAY` ile aynı
// desen: balon orada bağlam değiştiriyor (bkz. gorevBaglami).
const GOREV_DETAY_ROTA = /^\/yonetim\/(?:[^/]+\/)?gorevler\/[^/]+$/;
// F1: aç/toggle olay adları TEK KAYNAK (mesajlasmaBridge) — köprü ile aynı sözleşme.
export const TOGGLE_EVENT = MESAJLASMA_TOGGLE_EVENT;
export const OPEN_EVENT = MESAJLASMA_OPEN_EVENT;

// FAZ-60 — "TEK PENCERE" EŞİĞİ (telefon + dikey tablet).
//
// Bu eşiğin ALTINDA pencere zaten tüm ekranı kaplar: boy diye bir seçim yoktur,
// liste ve sohbet tek panede sıralanır, üst şeritte yalnız kapat düğmesi kalır
// (kullanıcı: "sohbete tıklayınca mobilin tamamını kaplıyor, yukarıda çarpının
// olması yeterli").
//
// FAZ-66: sayının kendisi `olcu.js`e taşındı — ChatThread de aynı eşiği
// kullanıyor (mobilde konum otomatik aranıyor) ve buradan içe aktarması
// dairesel bağımlılık olurdu. Dışa aktarım geriye uyum için duruyor.
const isMobile = tekPencereMi;

// FAZ-60 — PENCERE BOYU HATIRLANIR.
// Kullanıcı: "orta boydayken kapandı → bir dahaki sefer orta boydan açılsın;
// tam ekrandayken kapatıldıysa tam ekran açılsın." Boy, bileşen state'inde
// zaten oturum boyunca korunuyordu; localStorage bunu SAYFA YENİLENSE DE
// taşır (kabuk her rotada yeniden kurulabiliyor).
const BOY_LS = "msjPencereBoy";
const BOYLAR = ["kucuk", "orta", "tam"];
export const boyOku = () => {
  try {
    const v = localStorage.getItem(BOY_LS);
    return BOYLAR.includes(v) ? v : "kucuk";
  } catch {
    return "kucuk";
  }
};
const boyYaz = (v) => {
  try {
    localStorage.setItem(BOY_LS, v);
  } catch {
    /* özel sekme / kota — boy hatırlanmaz, akış bozulmaz */
  }
};

// FAZ-94 — tür/segment/süzgeç mantığı `sohbetKovalari.js`e taşındı.
// Sebep: telefon rotası ve paylaşılan liste de aynı kuralları okuyor;
// buradan almaları ChatDock ↔ SohbetListesi döngüsü üretiyordu.
// Yeniden dışa aktarım KALICI: sistemdeki ve testlerdeki
// `import { convKind } from ".../ChatDock"` çağrıları değişmedi.
export {
  convKind,
  MSJ_SEGMENTS_MAP,
  MSJ_SEGMENTS,
  visibleSegments,
  GOREV_ALT_SUZGEC,
  filterConvsBySegment,
  gorevKovaSayilari,
} from "./sohbetKovalari";

// Chip'li sekme şeridi — hem dock hem tam-sayfa listede aynı görünüm.
// Tek sekme kalırsa şerit TAMAMEN gizlenir (zero-trace: tek seçenek varken
// sekme göstermenin anlamı yok — ilk açılış: yalnız Görevler, şerit yok).
export function ConvSegments({ segments, value, onChange }) {
  if (!segments || segments.length <= 1) return null;
  return (
    <div className="msj-segs" role="tablist" aria-label="Sohbet filtreleri">
      {segments.map((s) => (
        <button
          key={s.key}
          type="button"
          role="tab"
          aria-selected={value === s.key}
          className={`msj-seg ${value === s.key ? "is-active" : ""}`}
          onClick={() => onChange(s.key)}
        >
          {s.label}
          {s.locked && (
            <LockClosedIcon
              className="msj-seg-lock"
              title="Özellik kapalı — salt-okunur"
              aria-label="Özellik kapalı — salt-okunur"
            />
          )}
        </button>
      ))}
    </div>
  );
}

// FAZ-55/17 — ALT SÜZGEÇ, ÜÇÜNCÜ (ve son) DENEME.
//
// Kullanıcı iki turdur "saçma duruyor / hâlâ beğenmedim, daha MANTIKLI yap"
// dedi. İlk iki deneme yalnız biçimi değiştiriyordu (eşit hap → içerik-oranlı
// hap → segment kutusu); asıl eksik BİLGİYDİ: hangi kovada kaç sohbet olduğunu
// görmeden seçmek zorundaydınız, boş bir kovaya tıklayıp "sohbet yok" ile
// karşılaşmak da cabası.
//
// Yeni yapı: üst sekmelerle AYNI dil (alt çizgili sekme) ama ikincil ölçekte,
// üstelik her kovanın SAYISI yanında. Sayı 0 ise kova soluk ve tıklanamaz —
// boş kovaya götürmeyen bir süzgeç, süzgecin kendisi kadar bilgi verir.
// Renk yalnız SEÇİLİ sekmenin altındaki çizgide (açık=mavi, onay=mor,
// tamamlanan=yeşil) — sohbet kartlarının rengiyle aynı sözlük.
export function GorevAltSuzgec({ value, onChange, sayilar = {} }) {
  return (
    <div className="msj-substat" role="tablist" aria-label="Talep durumu">
      {GOREV_ALT_SUZGEC.map((s) => {
        const adet = sayilar[s.key] ?? 0;
        const bos = adet === 0 && value !== s.key;
        return (
          <button
            key={s.key}
            type="button"
            role="tab"
            aria-selected={value === s.key}
            disabled={bos}
            className={`msj-substat-seg msj-substat-chip--${s.key} ${
              value === s.key ? "is-active" : ""
            } ${bos ? "is-bos" : ""}`}
            onClick={() => onChange(s.key)}
          >
            <span className="msj-substat-ad">{s.label}</span>
            <span className="msj-substat-sayi">{adet}</span>
          </button>
        );
      })}
    </div>
  );
}

export default function ChatDock() {
  const { uiOn, can } = usePermissions();
  const moduleOn = useModuleEnabled("mesajlasma");
  const navigate = useNavigate();
  // FAZ-90: telefonda başlatıcı balon yok (alt barın merkez düğmesi açıyor)
  const katmanAdi = useKatman();
  const telefonKatmani = katmanAdi === "telefon";
  const msjFeatures = useMsjFeatures();

  const [open, setOpen] = useState(false);
  // FAZ-52 — pencere modu: kucuk | orta | tam.
  // Kullanıcı kararı (2026-07-27): tek düğmeyle boy DÖNDÜRMEK kafa karıştırıyordu
  // ("tıklayınca büyümesin"). Artık iki AYRI düğme var, mac/windows mantığı:
  //   • Orta düğmesi  : orta ↔ küçük; TAM EKRANDAN da orta'ya iner (FAZ-60)
  //   • Tam düğmesi   : tam ↔ önceki boy (aç/kapa)
  // FAZ-60: ilk açılış artık "kucuk" DEĞİL — en son bırakılan boy.
  const [size, setSize] = useState(boyOku);
  // Tam ekrandan çıkınca hangi boya döneceğimiz (mac'te "restore" davranışı).
  const [oncekiBoy, setOncekiBoy] = useState("kucuk");
  const [view, setView] = useState("list"); // list | new
  // FAZ-37: varsayılan segment YOK — ilk görünen sekmeye effect'le oturur
  // (ilk açılış: yalnız Görevler açıksa "gorev"; sabit "kisi" KALDIRILDI).
  const [segment, setSegment] = useState(null);
  const [gorevAlt, setGorevAlt] = useState("acik"); // Görevler alt-süzgeci (açık | onay | tamam)
  const [activeConv, setActiveConv] = useState(null); // {id, title}
  const [taskFlow, setTaskFlow] = useState(null); // G9: geçici görev-akışı (conversation oluşmadan) {targets, unitTarget}
  const [convs, setConvs] = useState(null);
  // FAZ-51/52: toplam okunmamış artık EKRANDA gösterilmiyor (rozet zilde).
  // Yine de takip ediliyor: 'yeni mesaj geldi' tınısı bu sayının ARTIŞINDAN
  // anlaşılıyor ve UNREAD_EVENT dış dinleyicilere yayınlanıyor. Render'a
  // girmediği için state değil ref (gereksiz yeniden çizim yok).
  const [mobilePane, setMobilePane] = useState("list");

  /* FAZ-92 — ALT BAR SOHBET LİSTESİNDE GÖRÜNÜR, SOHBETİN İÇİNDE GİZLİ.
     Bayrak <html>'e yazılır; barın CSS'i onu okur (AltBar.css). Neden bayrak:
     ChatDock body'ye portal'lanıyor, alt bar ise kabuğun içinde — React
     ağacından birbirlerini göremezler. Sistemin bu deseni zaten var
     (data-msj-dock, data-gk-detay).

     FAZ-94 — BAYRAĞIN SAHİBİ DEĞİŞTİ. Telefonda pencere artık hiç açılmıyor
     (olaylar rotaya gidiyor), bayrağı sohbet ROTALARI yazıyor
     (SohbetDetayPage / YeniSohbetPage). Burada `open` telefonda asla true
     olamayacağı için koşul aynı kalıyor ama negatif dalda ARTIK SİLİNMİYOR:
     iki sahibi olan bir özniteliği biri "benim değilse yok et" mantığıyla
     yönetirse, rotanın yazdığı bayrağı ilgisiz bir yeniden çizimde
     süpürürdü. */
  useEffect(() => {
    if (!open || !telefonKatmani) return undefined;
    const kok = document.documentElement;
    kok.setAttribute("data-msj-ekran", mobilePane === "list" ? "liste" : "detay");
    return () => kok.removeAttribute("data-msj-ekran");
  }, [open, telefonKatmani, mobilePane]);
  const [cardW, setCardW] = useState(() => Number(localStorage.getItem("msjCardW")) || 0); // E3

  const prevUnreadRef = useRef(0);
  const firstUnreadRef = useRef(true); // ilk yoklama SESSİZ (sayfa açılışında çalmasın)
  // FAZ-80: balondaki SAYAÇ rozeti için sayı artık render'a giriyor.
  // (FAZ-51'de "ekranda gösterilmiyor" denip ref'e alınmıştı; kullanıcı
  // 2026-07-30'da geri istedi: "yeşil nokta yerine kaç tane mesaj varsa
  // sayısını gösterelim, 9+ gibi".)
  const [unreadTotal, setUnreadTotal] = useState(0);
  const cardRef = useRef(null); // E3: resize referansı
  const canRender = uiOn && moduleOn && can("mesajlasma.view");

  const segs = visibleSegments(msjFeatures, convs);
  const firstSegKey = segs[0]?.key || null;
  useEffect(() => {
    setSegment((cur) => (cur === null ? firstSegKey : cur));
  }, [firstSegKey]);

  // FAZ-60: boy her değişimde yazılır — "kapanışta kaydet" YETMEZ; kullanıcı
  // pencereyi kapatmadan sekmeyi yenileyebilir ya da rota değişimi pencereyi
  // kapatabilir (aşağıdaki effect), o yolda kapatma düğmesine hiç basılmaz.
  useEffect(() => {
    boyYaz(size);
  }, [size]);

  // FAZ-78 — TEK PENCERE MODUNDA KLAVYE PAYINI PENCERE DE OKUR.
  // FAZ-73'te bu düzeltme yalnız görev detayındaki tam-ekran sohbete konmuştu;
  // oysa mobilde ASIL sohbet yüzeyi burasıdır. `position: fixed` layout
  // viewport'a yerleşir, klavye ise VISUAL viewport'u küçültür → yazı kutusu
  // klavyenin altında kalır. Ölçüm JS'ten gelir, yerleşim CSS'ten
  // (--kb-h / --kb-top; bkz. useKlavyeAlani).
  useKlavyeAlani(open && isMobile(), cardRef);

  // FAZ-60 — ROTA DEĞİŞİNCE KAPLAYAN PENCERE KAPANIR.
  //
  // Hata: tam ekran sohbet açıkken sidebar'dan sayfa seçilince sayfa ARKADA
  // açılıyor, ekranda hiçbir şey değişmiyordu ("tam ekran sabit kalıyor").
  // Pencere ekranı KAPLIYORSA (tam ekran ya da tek-pencere eşiği altı) yeni
  // sayfayı göstermek için kapanır; küçük/orta boyda kapanmaz — o boylarda
  // sayfa zaten görünür ve sohbeti kapatmak taşınabilirliği bozardı
  // (dock'ın varlık sebebi rotadan bağımsız açık kalmasıdır).
  const { pathname } = useLocation();

  /* FAZ-99 / Y-5 — TABLETTE TALEP DETAYINDA BALON BAĞLAM DEĞİŞTİRİR.

     GERÇEK HATA: talep detayında sohbete girmenin tablette HİÇBİR yolu yoktu.
     Zincir — (1) `gorev.css` dar katmanda balonu `display:none` ile gizliyordu,
     gerekçesi "alttaki tam genişlik 'Sohbet' barı kalır"dı; (2) o bar (.gk-chatfab)
     FAZ-94'te silindi; (3) yerini alan alt bar merkez düğmesi yalnız telefonda
     çiziliyor. Üçü birleşince tablette sayfada tek bir sohbet girişi kalmadı.

     Çözüm kullanıcının kendi önerisi (2026-08-02): "bu sayfada yine aynı
     mantıkta sohbet kısmı olsun; detay sayfasına gelince rengi değişsin ve
     üzerine tıklayınca yine sorsun: bu talebin sohbeti mi yoksa sohbet mi —
     mobilin aynısı." Yani telefondaki merkez düğmenin davranışı, balonda.

     YALNIZ TABLET: masaüstünde sohbet zaten sağ sütunda açık duruyor, soru
     anlamsız olurdu. */
  const gorevBaglami =
    katmanAdi === "tablet" && GOREV_DETAY_ROTA.test(pathname);
  const [sohbetSecimi, setSohbetSecimi] = useState(false);
  // Rota değişince menü kapanır — açık menüyle sayfa değişmesi kafa karıştırır.
  useEffect(() => {
    setSohbetSecimi(false);
  }, [pathname]);
  const balonaBasildi = () => {
    if (gorevBaglami) {
      setSohbetSecimi((a) => !a);
      return;
    }
    setOpen(true);
  };

  const rotaRef = useRef(pathname);
  useEffect(() => {
    if (pathname === rotaRef.current) return;
    rotaRef.current = pathname;
    setOpen((acik) => (acik && (size === "tam" || isMobile()) ? false : acik));
  }, [pathname, size]);

  // FAZ-72 — PENCERE AÇIKKEN YÜZEN GEZİNME ARACI YOLDAN ÇEKİLİR.
  //
  // Ölçüm (gerçek tarayıcı, 1600×1000): `.floating-nav-wrap` (x 1387→1584,
  // y 942→984) ile pencerenin GÖNDER düğmesi (x 1520→1558, y 921→959)
  // 38×17 px örtüşüyor — düğmenin ALT YARISI ölü. Merkezi açıkta kaldığı için
  // "bazen gidiyor bazen gitmiyor" gibi görünüyordu. Araç sürüklenebilir olduğu
  // için konumu satır-içi `left/top` yazılıyor; CSS onu yalnız `!important` ile
  // ezebiliyor (bkz. chat.css). Kural pencere kapanınca kalkar, kullanıcının
  // kendi taşıdığı konum aynen geri gelir.
  useEffect(() => {
    if (!open) return undefined;
    document.documentElement.setAttribute("data-msj-dock", "acik");
    return () => document.documentElement.removeAttribute("data-msj-dock");
  }, [open]);

  // FAZ-52: sidebar hizalaması artık ÖLÇÜLMÜYOR.
  //
  // Eskiden burada `.sidebar` düğümünü bulup ResizeObserver ile genişliğini
  // ölçen bir effect vardı ve iki yerden bozuluyordu:
  //   • Rota değişince sidebar düğümü yeniden kuruluyor → observer boşta kalan
  //     eski düğümü izlemeye devam ediyor, ölçüm donuyordu.
  //   • Effect yalnız `size` değişince koşuyordu → sidebar açılıp kapanınca
  //     (aynı size'da) yeniden bağlanmıyordu.
  // Sonuç: tam ekran pencere sidebar'ın altında kalıyor ya da boşluk bırakıyordu.
  //
  // Artık kabuk (BelediyeLayout) sidebar durumunu `--md-sidebar-w` olarak
  // body'ye yazıyor; hizalamayı CSS yapıyor. Ölçüm yok → bozulacak bir şey yok.

  // ── Unread poll (TEK sahip) + geliş sesi + navbar yayını ───────────
  // Ses: mesajlaşma GLOBAL anahtarına bağlı (playMsjReceived kendi içinde
  // kapalıysa susar) — genel bildirim sesinden bağımsız. Dock kapalı/arka
  // plandayken "yeni mesaj" tınısını burası çalar; açık sohbette ChatThread
  // çalar (aynı geliş tonu + debounce → çift ses birleşir).
  const pollUnread = useCallback(async () => {
    try {
      const n = await fetchUnreadTotal();
      setUnreadTotal(Number(n) || 0); // FAZ-80: balon rozeti
      window.dispatchEvent(new CustomEvent(UNREAD_EVENT, { detail: { unread: n } }));
      if (!firstUnreadRef.current && n > prevUnreadRef.current) playMsjReceived();
      firstUnreadRef.current = false;
      prevUnreadRef.current = n;
    } catch {
      /* sessiz */
    }
  }, []);

  // ── FAZ-77 — OKUNMAMIŞ SAYISI ARTIK PERİYODİK YOKLANMIYOR ───────────────
  //
  // Kullanıcı (2026-07-30): "sistemin genelinde bir yenilenme yapısı var,
  // kaldıralım." ÖLÇÜM (gerçek tarayıcı, 60 sn, HER sayfada — görev ata,
  // görevlerim, detay, dashboard): `/api/mesajlasma/unread-count/` ucuna
  // **4 istek** (15 sn'de bir). Sohbet KAPALIYKEN de, kullanıcı hiçbir şey
  // yapmasa da dönen tek şey buydu; FAZ-65'te "periyodik yoklama yalnız
  // sohbette kalsın" denmişti ama bu yoklama pencereye DEĞİL uygulamanın
  // tamamına bağlıydı — yani sistem genelinde bir yenilenmeydi.
  //
  // Yerine FAZ-65'in tetikleri: rota değişimi + sekmeye dönüş + pencere
  // odağı. Sohbet penceresi AÇIKKEN sayı zaten kendi listesinden ve mesaj
  // yoklamasından tazelenir.
  //
  // BEDEL (bilinçli): ekranda hiç hareket etmeden beklerken yeni mesaj sesi
  // ANINDA gelmez — sayfa değiştirince, sekmeye dönünce ya da sohbeti açınca
  // gelir. Kullanıcıya bildirildi.
  useEffect(() => {
    if (!canRender) return undefined;
    pollUnread();
    const onVis = () => !document.hidden && pollUnread();
    document.addEventListener("visibilitychange", onVis);
    window.addEventListener("focus", onVis);
    return () => {
      document.removeEventListener("visibilitychange", onVis);
      window.removeEventListener("focus", onVis);
    };
  }, [canRender, pollUnread, pathname, open]);

  const loadConvs = useCallback(async () => {
    try {
      setConvs(await fetchConversations());
    } catch {
      setConvs((prev) => prev || []);
    }
  }, []);

  useEffect(() => {
    if (!canRender || !open) return undefined;
    loadConvs();
    const iv = setInterval(() => {
      if (!document.hidden) loadConvs();
    }, 12000);
    return () => clearInterval(iv);
  }, [canRender, open, loadConvs]);

  // Dış olaylar: navbar toggle + "sohbette aç" (görev detayından vb.)
  useEffect(() => {
    if (!canRender) return undefined;

    /* FAZ-94 — TELEFONDA KÖPRÜLER ROTAYA GİDER.
       `mesajlasma:open` / `:toggle` / `:yeni-sohbet` olayları DURUYOR; SMS
       derin linkleri, bildirim köprüleri (resolveNotificationTarget) ve
       gotoMessage() tek satır bile değişmeden çalışsın diye. Değişen yalnız
       bu dinleyicinin cevabı: pencere açmak yerine `navigate`.

       Pencere yine de MOUNT KALIYOR (render'ı boş) — okunmamış yoklamasının
       TEK sahibi burasıdır ve alt bardaki sayaç onun yaydığı olaydan
       besleniyor. Bileşeni telefonda hiç kurmasaydık rozet sessizce
       sıfırlanırdı (FAZ-94 §9'daki ilk risk). */
    const onToggle = () => {
      if (telefonKatmani) {
        navigate("/yonetim/sohbet");
        return;
      }
      setOpen((v) => !v);
    };
    const onOpen = (e) => {
      const convId = Number(e?.detail?.conversationId) || null;
      if (telefonKatmani) {
        navigate(convId ? `/yonetim/sohbet/${convId}` : "/yonetim/sohbet");
        return;
      }
      setOpen(true);
      if (convId) {
        setActiveConv({ id: convId, title: e?.detail?.title || "" });
        setMobilePane("thread");
        setView("list");
      }
    };
    // FAZ-75 — "Yeni Görev" artık BU paneli açar (Görev Ata'daki sayfa-içi form
    // kaldırıldı). Pencere "Yeni" görünümünde ve ORTA boyda açılır: kullanıcı
    // doğrudan kişi listesini görür, seçer, "Sohbeti Başlat" der.
    // Boy KASITLI olarak ezilir (hafızadaki son boy değil): akış kişi listesi
    // göstermekle başlıyor, küçük boyda liste okunmuyor, tam ekran ise sayfayı
    // tamamen yutuyor. Kullanıcı sonra elle küçültebilir; bir sonraki normal
    // açılış yine hatırlanan boydan gelir (boyYaz effect'i onu yazar).
    const onNew = (e) => {
      if (telefonKatmani) {
        navigate("/yonetim/sohbet/yeni", { state: { donus: rotaRef.current } });
        return;
      }
      const boy = e?.detail?.boy === "tam" || e?.detail?.boy === "kucuk" ? e.detail.boy : "orta";
      setOpen(true);
      setSize(boy);
      setTaskFlow(null);
      setActiveConv(null);
      setView("new");
      setMobilePane("list");
    };
    window.addEventListener(TOGGLE_EVENT, onToggle);
    window.addEventListener(OPEN_EVENT, onOpen);
    window.addEventListener(MESAJLASMA_NEW_EVENT, onNew);
    return () => {
      window.removeEventListener(TOGGLE_EVENT, onToggle);
      window.removeEventListener(OPEN_EVENT, onOpen);
      window.removeEventListener(MESAJLASMA_NEW_EVENT, onNew);
    };
  }, [canRender, telefonKatmani, navigate]);

  const openConv = (c) => {
    setTaskFlow(null); // G9: liste sohbeti açılınca görev-akışını kapat
    setActiveConv({ id: c.id, title: c.title });
    setMobilePane("thread");
    setConvs((prev) => (prev || []).map((x) => (x.id === c.id ? { ...x, unread: 0 } : x)));
  };

  const onStarted = (convId) => {
    setTaskFlow(null); // G9
    setView("list");
    setActiveConv({ id: convId, title: "" });
    setMobilePane("thread");
    loadConvs();
  };

  // E1: ChatThread başlık menüsünden "Sohbeti sil" (gizle) yapılınca — listeden
  // düş + açık sohbeti kapat. API çağrısı ChatThread'de; burası yalnız yereli tazeler.
  const onConvHidden = (convId) => {
    setConvs((prev) => (prev || []).filter((x) => x.id !== convId));
    if (activeConv?.id === convId) {
      setActiveConv(null);
      setMobilePane("list");
    }
  };

  // FAZ-60 — boy değiştiriciler.
  // setSize güncelleyicisinin İÇİNDE setOncekiBoy çağırmak (eski hâli) yan
  // etkidir: React güncelleyiciyi iki kez çalıştırabilir (StrictMode) ve
  // "önceki boy" yanlış yazılır. Karar burada, güncelleyici saf.
  const tamDegistir = () => {
    if (size === "tam") {
      setSize(oncekiBoy || "kucuk");
      return;
    }
    setOncekiBoy(size);
    setSize("tam");
  };
  const ortaDegistir = () => {
    if (size === "tam") {
      // Tam ekrandan inerken "geri dönülecek boy" da orta olur; aksi hâlde
      // tam ekran düğmesi bir sonraki turda kullanıcıyı küçüğe fırlatırdı.
      setOncekiBoy("orta");
      setSize("orta");
      return;
    }
    setSize(size === "orta" ? "kucuk" : "orta");
  };

  // E3: sol kenardan sürükle → dock genişliğini ayarla (localStorage'da kalıcı).
  const startResize = (e) => {
    e.preventDefault();
    const startX = e.clientX;
    const startW = cardRef.current?.getBoundingClientRect().width || cardW || 380;
    const onMove = (ev) => {
      const dW = startX - ev.clientX; // sola çek → genişlet
      const max = Math.min(900, window.innerWidth - 40);
      setCardW(Math.max(340, Math.min(Math.round(startW + dW), max)));
    };
    const onUp = () => {
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mouseup", onUp);
      setCardW((w) => {
        if (w) localStorage.setItem("msjCardW", String(w));
        return w;
      });
    };
    window.addEventListener("mousemove", onMove);
    window.addEventListener("mouseup", onUp);
  };

  if (!canRender) return null;

  const mobil = isMobile();
  const listHidden = mobil && mobilePane !== "list";
  const threadHidden = mobil && mobilePane !== "thread";

  const kart = (
    <div
      ref={cardRef}
      className={`msj-card ${size === "orta" ? "is-orta" : ""} ${size === "tam" ? "is-tam" : ""}`}
      role="dialog"
      aria-label="Mesajlaşma"
      // FAZ-52: tam ekranda sol hizalama artık inline stil DEĞİL — CSS
      // `--md-sidebar-w` değişkeninden okur (kabuk yazar). Burada yalnız
      // küçük kartın kullanıcı-ayarlı genişliği kalır.
      style={size === "kucuk" && !mobil && cardW ? { width: cardW } : undefined}
    >
      {/* E3: sol kenardan sürükle → genişlik ayarı (masaüstü, küçük kartta) */}
      {size === "kucuk" && !mobil && (
        <div className="msj-resizer" onMouseDown={startResize} title="Genişliği ayarla" aria-hidden="true" />
      )}
      <div className="msj-head">
        <span className="msj-head-title">Kurum İçi Mesajlaşma</span>

        {/* FAZ-55 — düğme SIRASI (kullanıcı isteği, soldan sağa):
            1) TAM EKRAN  2) ORTA (ikincil boy)  3) KAPAT.
            Kapat en sağda kalır (yanlış tıklama riski en az olan uç). */}
        <button
          type="button"
          className="msj-head-btn msj-head-btn--boy"
          onClick={tamDegistir}
          title={size === "tam" ? "Tam ekrandan çık" : "Tam ekran"}
          aria-label={size === "tam" ? "Tam ekrandan çık" : "Tam ekran"}
        >
          {size === "tam" ? <ArrowsPointingInIcon /> : <ArrowsPointingOutIcon />}
        </button>

        {/* ORTA BOY düğmesi — FAZ-60: TAM EKRANDA DA ÇALIŞIR.
            Eskiden tam ekranda pasifti; küçüğe dönmek için önce tam ekrandan
            çıkmak gerekiyordu (kullanıcı: "tam ekrandayken de ortadaki ikon
            çalışsın, bir daha küçük ekrana dönebileyim; kapatıp açmaya gerek
            kalmasın"). Düğme artık adının söylediği şeyi yapar: her boydan
            "orta"ya gider, ortadayken küçültür. */}
        <button
          type="button"
          className="msj-head-btn msj-head-btn--boy"
          onClick={ortaDegistir}
          title={size === "orta" ? "Küçült" : "Orta boy"}
          aria-label={size === "orta" ? "Küçült" : "Orta boy"}
        >
          {/* FAZ-55: üç düğme üç AYRI ikon ailesi kullanır — tam ekran köşegen
              oklar, orta boy dikey büyüt/küçült, kapat çarpı. Eski Square2Stack
              tam-ekran oklarıyla karışıyordu (kullanıcı: "o olmamış"). */}
          {size === "orta" ? <MinusSmallIcon /> : <ChevronUpDownIcon />}
        </button>

        <button type="button" className="msj-head-btn" onClick={() => setOpen(false)} title="Kapat" aria-label="Kapat">
          <XMarkIcon />
        </button>
      </div>

      <div className="msj-body">
        <div className={`msj-list ${listHidden ? "is-hidden-mobile" : ""}`}>
          {view === "new" ? (
            <NewChatPanel
              onStarted={onStarted}
              onCancel={() => setView("list")}
              onStartTaskFlow={(p) => { setTaskFlow(p); setView("list"); setActiveConv(null); setMobilePane("thread"); }}
            />
          ) : segs.length === 0 ? (
            <div className="msj-empty" style={{ margin: "auto" }}>
              Şu anda açık bir sohbet özelliği yok.
            </div>
          ) : (
            <>
              <div className="msj-list-head">
                <span className="msj-list-title">Sohbetler</span>
                {(msjFeatures.serbest || msjFeatures.gorev) && (
                  <button type="button" className="msj-newbtn" onClick={() => setView("new")}>
                    <PlusIcon /> Yeni
                  </button>
                )}
              </div>
              <ConvSegments segments={segs} value={segment} onChange={setSegment} />
              {segment === "gorev" && (
                <GorevAltSuzgec
                  value={gorevAlt}
                  onChange={setGorevAlt}
                  sayilar={gorevKovaSayilari(convs)}
                />
              )}
              {/* FAZ-94 — satır çizimi paylaşılan bileşene taşındı; telefon
                  rotasındaki liste ile TEK gövdeden besleniyor. DOM birebir
                  aynı (sınıflar, sıra, boş durumlar) — kap değişti, liste değil. */}
              <SohbetListesi
                convs={convs}
                segment={segment}
                gorevAlt={gorevAlt}
                aktifId={activeConv?.id ?? null}
                onAc={openConv}
                /* FAZ-92 — kaydırınca başlık satırı ("Sohbetler" + Yeni)
                   gider, ÇİPLER kalır. Liste kabı zaten kendi içinde
                   kayıyor; yapışkanlık kurmak yerine kaydırma durumunu
                   karta bayrak olarak yazıyoruz (aynı desen: data-gk-detay). */
                onScroll={(e) => {
                  const kart = e.currentTarget.closest(".msj-card");
                  if (!kart) return;
                  const kaydi = e.currentTarget.scrollTop > 8 ? "1" : "0";
                  if (kart.dataset.kaydi !== kaydi) kart.dataset.kaydi = kaydi;
                }}
              />
            </>
          )}
        </div>

        <div className={`msj-thread ${threadHidden ? "is-hidden-mobile" : ""}`}>
          {taskFlow ? (
            <TaskFlowPanel
              targets={taskFlow.targets}
              unitTarget={taskFlow.unitTarget}
              onStarted={(id) => { setTaskFlow(null); onStarted(id); }}
              onClose={() => { setTaskFlow(null); setView("new"); setMobilePane("list"); }}
            />
          ) : activeConv ? (
            <ChatThread
              key={activeConv.id}
              conversationId={activeConv.id}
              initialTitle={activeConv.title}
              variant="dock"
              onNavigate={() => setOpen(false)}
              onBack={() => setMobilePane("list")}
              onHidden={onConvHidden}
              onSwitchConversation={onStarted}
            />
          ) : (
            !mobil && (
              <div className="msj-empty" style={{ margin: "auto" }}>
                <ChatBubbleLeftRightIcon className="msj-empty-icon" />
                Bir sohbet seçin.
              </div>
            )
          )}
        </div>
      </div>
    </div>
  );

  return (
    <>
      {/* FAZ-80 — YEŞİL NOKTA → OKUNMAMIŞ SAYACI.
          Kullanıcı (2026-07-30): "yeşil nokta yerine kaç tane mesaj varsa
          sayısını gösterelim, 9+ gibi bir şey olsun, biraz büyük bir şekilde
          yuvarlak içinde."
          Nokta "bir şey var" diyordu ama "ne kadar" demiyordu; okunmamış 1 ile
          40 arasında hiçbir fark yoktu. Sayı YOKKEN rozet hiç çizilmez —
          nokta gibi "her zaman yeşil" durmaz (o hâlde sinyal olmaktan çıkar).
          9'dan sonrası "9+": iki haneli sayı 62px'lik balonun kenarında
          ikonu eziyordu. */}
      {/* FAZ-90: TELEFONDA BALON ÇİZİLMEZ — sohbetin açma yüzeyi alt barın
          merkez düğmesi oldu. Tablette ve masaüstünde balon AYNEN duruyor
          (orada alt bar yok). CSS ile gizlemek yetmezdi: düğme DOM'da kalır,
          Tab ile odaklanılır ve sayacı iki yerde çizilirdi. */}
      {!open && !telefonKatmani && (
        <button
          type="button"
          className={`msj-launcher${gorevBaglami ? " msj-launcher--gorev" : ""}`}
          onClick={balonaBasildi}
          aria-label={gorevBaglami ? "Sohbet seç" : "Mesajlar"}
          title={gorevBaglami ? "Sohbet seç" : "Mesajlar"}
          aria-haspopup={gorevBaglami ? "menu" : undefined}
          aria-expanded={gorevBaglami ? (sohbetSecimi ? "true" : "false") : undefined}
        >
          {/* FAZ-102 — İKON HER YERDE AYNI.
              Kullanıcı (2026-08-02): "mobilde sohbetin ikonunu değiştirdin ya,
              aynı mantıkta web'teki kısımda da mobilde kullandığımız ikonu
              kullanalım."

              FAZ-92'de alt barın merkezi `ChatBarIcon`a geçmiş, balon ise
              "orada ölçek ve zemin farklı" denerek `ChatLauncherIcon` ile
              bırakılmıştı. Gerekçe okunabilirlikti (24px'te üç nokta birbirine
              giriyordu) ve o hâlâ doğru — ama ikonun KAVRAMI aynı: "sohbet".
              Aynı kavramın iki yüzeyde iki ayrı çizimi olması, telefondan
              web'e geçen kullanıcıya iki ayrı şey gibi okunuyor. Tek çizim
              kazanır; 68px'lik balonda da net duruyor. */}
          <ChatBarIcon />
          {unreadTotal > 0 && !gorevBaglami ? (
            <span
              className="msj-launcher-count"
              aria-label={`${unreadTotal} okunmamış mesaj`}
            >
              {unreadTotal > 9 ? "9+" : unreadTotal}
            </span>
          ) : null}
        </button>
      )}

      {/* FAZ-99 / Y-5 — TABLETTE "HANGİ SOHBET?" SORUSU.
          Telefonda bu soruyu alt barın merkez düğmesi soruyor (FAZ-97 m5);
          tablette alt bar yok, soruyu balon soruyor. Aynı iki seçenek, aynı
          sıra: varsayılan iş (talebin sohbeti) ÖNCE. */}
      {sohbetSecimi && (
        <>
          <div
            className="msj-launcher-perde"
            onClick={() => setSohbetSecimi(false)}
            aria-hidden="true"
          />
          <div
            className="msj-launcher-menu pop-ok"
            data-ok="alt"
            data-ok-x="sag"
            role="menu"
          >
            <div className="msj-launcher-menu-bas">Hangi sohbet?</div>
            <button
              type="button"
              role="menuitem"
              className="msj-launcher-menu--vurgu"
              onClick={() => {
                setSohbetSecimi(false);
                window.dispatchEvent(new CustomEvent(GOREV_SOHBET_EVENT));
              }}
            >
              Bu talebin sohbeti
            </button>
            <button
              type="button"
              role="menuitem"
              onClick={() => {
                setSohbetSecimi(false);
                setOpen(true);
              }}
            >
              Tüm sohbetler
            </button>
          </div>
        </>
      )}
      {open && createPortal(<div className={`msj-overlay ${size === "tam" ? "is-tam" : ""}`}>{kart}</div>, document.body)}
    </>
  );
}
